import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';

import { useUtcToday } from '@klareospace/pharos-lib-front-utils';

import { useOwnTenantBillingConfiguration } from './use-own-tenant-billing-configuration';
import { computeFreeTrialBannerState } from '../utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseFreeTrialBannerReturn {
  buttonLabel: string;
  message: string;
  onChoosePlan: () => void;
  visible: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Resolves the frontoffice free-trial banner's visibility and translated copy from the tenant's own recorded trial. */
export function useFreeTrialBanner(): UseFreeTrialBannerReturn {
  const { t } = useTranslation('billing');
  const navigate = useNavigate();
  const todayUtc = useUtcToday();
  const { data } = useOwnTenantBillingConfiguration();
  const { daysLeft, durationDays, visible } = computeFreeTrialBannerState(data, todayUtc);

  function onChoosePlan(): void {
    void navigate({ to: '/settings/billing' });
  }

  return {
    buttonLabel: t('banner.choosePlan'),
    message: t('banner.message', { count: daysLeft, durationDays }),
    onChoosePlan,
    visible,
  };
}
